<script setup lang="ts">
const { parameters } = useParameters();

const open = ref(false);

function toggleOpenText() {
  open.value = !open.value;
}

const htmFooterText = computed(() => {
  const text = parameters.value?.footer_html || '';
  const currentAppUrl = appUrlUpper();
  const siteUrlTemplate = '{site_url}';
  const layout = useLayoutStore();

  const prefix = ref('');

  if (layout.footerDescription) {
    prefix.value = `<h2>${layout.footerDescription}</h2><p><br /></p>`;
  }

  if (currentAppUrl && siteUrlTemplate && text) {
    return `${prefix.value} <h3>${text.replaceAll(siteUrlTemplate, currentAppUrl)}</h3>`;
  }

  return `${prefix.value} <h3>${text}</h3>`;
});

const hasHtmlFooterText = computed<boolean>(() => {
  return !!htmFooterText.value.replace(/(<([^>]+)>)/gi, '');
});
</script>

<template>
  <div
    v-if="hasHtmlFooterText"
    class="footer-section text-section"
  >
    <div
      class="text-[.7rem] text-footer-texts text-center overflow-hidden pb-2 min-w-full"
      :class="open ? 'max-h-full mb-2' : 'max-h-16'"
    >
      <div
        class="footer-text-dynamic"
        v-html="htmFooterText"
      ></div>
    </div>

    <button
      class="toggle-btn"
      :class="{ open: open }"
      @click="toggleOpenText"
    >
      {{ open ? $t('footer.see_less') : $t('footer.see_more') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.text-section {
  @apply relative;
}

.footer-text-dynamic {
  @apply leading-4 md:leading-5 text-center text-[.65rem] md:text-[.7rem];

  p,
  h2 {
    @apply mb-4;
  }

  b,
  strong {
    font-weight: 600;
  }

  hr {
    @apply border-solid border-t opacity-20 border-t-footer-texts;
  }
}

.toggle-btn {
  @apply text-footer-texts/70 text-[.7rem] bg-gradient-to-t from-footer-bg-primary to-transparent z-10
  w-full hover:opacity-100 absolute bottom-3 md:bottom-5 pt-8;

  &.open {
    @apply pt-0;
  }
}
</style>
